import type { StatusTone } from '../../StatusBadge.js';
import type { WorkOrderView } from './types.js';

/**
 * PMS durum rozetlerinin tonu (plan M7 Task 14b; A17): referans görüntüde Low (öncelik) yeşil,
 * In Progress (PMS iş emri) turuncu. Renk değerleri tasarım token'larıdır (README "Tasarım
 * değerleri"); eşleme tek yerde.
 */
const TONES: Readonly<Record<string, StatusTone>> = {
  on_time: 'success',
  completed: 'success',
  approved: 'success',
  low: 'success',
  due_soon: 'warning',
  pending: 'warning',
  in_progress: 'warning',
  medium: 'warning',
  overdue: 'danger',
  returned: 'danger',
  high: 'danger',
  scheduled: 'info',
  planned: 'info',
  postponed: 'info',
  voided: 'neutral',
  cancelled: 'neutral',
};

export function pmsStatusTone(key: string): StatusTone {
  return TONES[key] ?? 'neutral';
}

export type WorkOrderStatusKey =
  | 'planned'
  | 'in_progress'
  | 'cancelled'
  | 'pending'
  | 'completed'
  | 'returned';

/**
 * İş emrinin ekranda gösterilen durumu (durum saklanmaz, türetilir; K39): raporlanmışsa kaydın
 * onay durumu (onaylı "Completed", bekleyen "Pending", iade "Returned"); değilse iş emrinin durumu.
 */
export function workOrderStatus(wo: Pick<WorkOrderView, 'status' | 'record'>): WorkOrderStatusKey {
  if (wo.record) {
    if (wo.record.status === 'approved') return 'completed';
    if (wo.record.status === 'returned') return 'returned';
    return 'pending';
  }
  if (wo.status === 'in_progress' || wo.status === 'cancelled') return wo.status;
  return 'planned';
}

/**
 * İş emri gecikmiş mi (ADR 0029 Ek M7f F3) [NR496 4.5.3c Not 1]: raporlanmamış ve iptal edilmemiş
 * iş emrinin vadesi (planlıda plan motorundan, plansızda hedef tarihten) geçmişse liste ve detayda
 * "Overdue" rozeti. Durum sunucudan gelir (`due.status`), saklanmaz.
 */
export function workOrderLate(wo: Pick<WorkOrderView, 'status' | 'record' | 'due'>): boolean {
  return wo.record === null && wo.status !== 'cancelled' && wo.due.status === 'overdue';
}
